import axios from "axios";
import ClassDetail from 'mediators/ClassDetail'

export default function getClassTeacherStudent(id, originalData=false) {

  if (typeof id !== 'number') {
    throw new Error('class ID (number) is missing. getClassTeacherStudent(classId)');
  }

	return new Promise((resolve, reject)=>{
		axios.put('/proxy', {
        'uri': `/g_clss_tch_stdt/${id}/`,
				'method': 'GET',
				'token': localStorage.getItem('token'),
			})

      .then(({ data }) => {
        if (data) {
          let clsRaw = data.classDetail;
          clsRaw.classStudentList = data.classStudentList;
          clsRaw.classTeacherList = data.classTeacherList;

          originalData ? resolve(data) : resolve(new ClassDetail(clsRaw));
        }
      })
      .catch((err) => {
        reject(err);
      })

	})
}



// WEBPACK FOOTER //
// ./src/controllers/controllers/class/getClassTeacherStudent.js